import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import { Platform, View } from 'react-native';
import { Text } from '@/components/Text';
import ResponsiveTextWeb from './ResponsiveTextWeb';
import { styles } from './styles';
import { IS_WEB } from '@/utils/platform';

function ResponsiveText({ children, style, fontSize, isFullWidth }) {
  return IS_WEB ? (
    <View style={styles.container}>
      <ResponsiveTextWeb
        style={[styles.textStyle, style && style]}
        fontSize={fontSize ?? useResponsiveFontSize(5)}
        isFullWidth={true}
      >
        {children}
      </ResponsiveTextWeb>
    </View>
  ) : (
    <View style={styles.container}>
      <Text
        adjustsFontSizeToFit={true}
        numberOfLines={1}
        style={[styles.textStyle, style && style]}
        isResponsiveText={true}
      >
        {children}
      </Text>
      {Platform.OS === 'android' && <Text>{'\u00A0'}</Text>}
    </View>
  );
}

export default ResponsiveText;
